import React from "react";
import { Skeleton } from "./Skeleton";

const INSIGHT_CARD_COUNT = 3;

/**
 * Skeleton loader matching MonthAtGlanceInsightsPanel layout (three insight cards).
 * Used across client dashboard when insights are loading.
 */
export function InsightsPanelSkeleton() {
  return (
    <div className="flex h-full min-h-0 w-full flex-col gap-3">
      {Array.from({ length: INSIGHT_CARD_COUNT }).map((_, i) => (
        <div key={i} className="flex min-h-0 flex-1 basis-0 flex-col">
          <div className="flex h-full min-h-[52px] w-full gap-3 rounded-2xl bg-white px-5 py-4 shadow-sm items-stretch">
            <Skeleton className="w-1 flex-none self-stretch rounded-full min-h-[44px]" />
            <div className="flex flex-col items-start gap-2 flex-1">
              <Skeleton className="h-4 w-full max-w-[240px]" />
              <Skeleton className="h-3 w-full max-w-[280px]" />
            </div>
          </div>
        </div>
      ))}
    </div>
  );
}
